import React from "react";
import { TripsContainer, TripsWrapper } from "./style";
import DriverCard from "../DriverCard";

function Trips({ drivers, onSelectDriver }) {
  return (
    <TripsWrapper>
      <TripsContainer>
        {drivers.length > 0 ? (
          drivers.map((driver, i) => (
            <div
              key={i}
              onMouseEnter={() => onSelectDriver(driver)}
              onMouseLeave={() => onSelectDriver(null)}
            >
              <DriverCard
                driverId={driver?._id}
                name={driver?.user?.name}
                imageSrc={driver?.user?.profile_img}
                status={driver?.availability}
              />
            </div>
          ))
        ) : (
          <p
            style={{
              fontSize: "18px",
              color: "#777",
              margin:15,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            🚗 لا يوجد حاليا سائقين متاحين أو ضمن رحالات
          </p>
        )}
      </TripsContainer>
    </TripsWrapper>
  );
}

export default Trips;
